import React from "react"
import { Box, Link, LinkProps } from "@mui/material"
import { useStyles } from "./styles"

interface Props extends LinkProps {
  replace?: boolean
  disabled?: boolean
}

export const LinkRouter: React.FC<React.PropsWithChildren<Props>> = props => {
  const { disabled, children, ...rest } = props
  const { classes } = useStyles()
  return (
    <>
      {disabled ? (
        <Box className={classes.disabledLink}>{children}</Box>
      ) : (
        <Link {...rest}>{children}</Link>
      )}
    </>
  )
}
